<div
  id="app-sidebar-10"
  class="w-[250px] h-screen hidden lg:block shrink-0 bg-primary-900 dark:bg-surface-950"
>
  <div class="flex flex-col h-full">
    <!-- Header -->
    <div class="flex items-center p-4 gap-3 shrink-0">
      <img src="assets/apple-touch-icon.png" class="w-15 h-15" />

      <div class="flex flex-col leading-tight">
        <span class="text-lg font-semibold text-white dark:text-surface-0">
          SDRF
        </span>
        <span class="text-xs text-gray-300">
          State Disaster Response Force
        </span>
      </div>
    </div>

    <!-- Main Navigation -->
    <div class="overflow-y-auto flex-1 p-2 flex flex-col gap-4">
      @if ((sidebarData$ | async); as sidebar) {
        <!-- Main Menu Items -->
        <div class="flex flex-col">
          @for (item of sidebar.mainItems; track item.label) {
            <a
              #rla="routerLinkActive"
              [routerLink]="item.link"
              [relativeTo]="relativeRoute"
              routerLinkActive
              [routerLinkActiveOptions]="{ exact: false }"
              [ngClass]="{
                'bg-white/10 !border-l-[#b45309] text-white': rla.isActive
              }"
              class="relative active-class flex items-center cursor-pointer p-2.5 gap-3 rounded-lg text-slate-400 transition-all duration-150 group border-l-4 border-l-transparent hover:bg-white/5 px-5 hover:text-white"
            >
              <i
                [class]="item.icon + ' text-base! leading-none!'"
                [ngClass]="{
                  'text-[#b45309] dark:text-surface-50': rla.isActive,
                  'text-white/60 group-hover:text-white/90': !rla.isActive
                }"
              ></i>
              <span class="font-medium text-base leading-tight">{{ item.label }}</span>
            </a>
          }
        </div>

        <!-- Settings Section (Collapsible) -->
        @if (sidebar.settingsItems && sidebar.settingsItems.length > 0) {
          <div class="flex flex-col">
            <div
              pStyleClass="@next"
              enterFromClass="hidden"
              enterActiveClass="animate-slidedown"
              leaveToClass="hidden"
              leaveActiveClass="animate-slideup"
              (click)="toggleSettings()"
              class="flex items-center cursor-pointer p-3 gap-4 transition-colors duration-150"
            >
              <span class="font-semibold text-slate-300 text-sm px-3">SETTINGS</span>
              <i
                [class]="
                  'pi text-base! leading-none! text-surface-500 dark:text-surface-400 ml-auto transition-transform duration-200 ' +
                  (settingsExpanded ? 'pi-angle-up' : 'pi-angle-down')
                "
              ></i>
            </div>

            <ul class="list-none m-0 overflow-hidden flex flex-col">
              @for (item of sidebar.settingsItems; track item.label) {
                <li>
                  <a
                    #rla="routerLinkActive"
                    [routerLink]="item.link"
                    [relativeTo]="relativeRoute"
                    routerLinkActive
                    [routerLinkActiveOptions]="{ exact: false }"
                    [ngClass]="{
                      'bg-white/10 !border-l-[#b45309] text-white': rla.isActive
                    }"
                    class="active-class flex items-center cursor-pointer p-2.5 gap-3 rounded-lg text-slate-400 transition-all duration-150 group border-l-4 border-l-transparent hover:bg-white/5 dark:hover:bg-surface-800 px-5 hover:text-white dark:hover:text-surface-50"
                  >
                    <i
                      [class]="item.icon + ' text-base! leading-none!'"
                      [ngClass]="{
                        'text-[#b45309] dark:text-surface-50': rla.isActive,
                        'text-white/60 group-hover:text-white/90': !rla.isActive
                      }"
                    ></i>
                    <span class="font-medium text-base leading-tight">{{ item.label }}</span>
                  </a>
                </li>
              }
            </ul>
          </div>
        }

        @if (sidebar.sdrfItems && sidebar.sdrfItems.length > 0) {
          <div class="flex flex-col">
            <div
              pStyleClass="@next"
              enterFromClass="hidden"
              enterActiveClass="animate-slidedown"
              leaveToClass="hidden"
              leaveActiveClass="animate-slideup"
              (click)="toggleSdrf()"
              class="flex items-center cursor-pointer p-3 gap-4 transition-colors duration-150"
            >
              <span class="font-semibold text-slate-300 text-sm px-3">SDRF WEBSITE</span>
              <i
                [class]="
                  'pi text-base! leading-none! text-surface-500 dark:text-surface-400 ml-auto transition-transform duration-200 ' +
                  (sdrfExpanded ? 'pi-angle-up' : 'pi-angle-down')
                "
              ></i>
            </div>

            <ul class="list-none m-0 overflow-hidden flex flex-col">
              @for (section of sidebar.sdrfItems; track section.label) {
                @for (item of section.children; track item.label) {
                  <li>
                    <a
                      #rla="routerLinkActive"
                      [routerLink]="item.link"
                      [relativeTo]="relativeRoute"
                      routerLinkActive
                      [routerLinkActiveOptions]="{ exact: false }"
                      [ngClass]="{
                        'bg-white/10 !border-l-[#b45309] text-white': rla.isActive
                      }"
                      class="active-class flex items-center cursor-pointer p-2.5 gap-3 rounded-lg text-slate-400 transition-all duration-150 group border-l-4 border-l-transparent hover:bg-white/5 dark:hover:bg-surface-800 px-5 hover:text-white dark:hover:text-surface-50"
                    >
                      <i
                        [class]="item.icon + ' text-base! leading-none!'"
                        [ngClass]="{
                          'text-[#b45309] dark:text-surface-50': rla.isActive,
                          'text-white/60 group-hover:text-white/90': !rla.isActive
                        }"
                      ></i>
                      <span class="font-medium text-base leading-tight">{{ item.label }}</span>
                    </a>
                  </li>
                }
              }
            </ul>
          </div>
        }
      }
    </div>

    <!-- Footer -->
    <div class="p-2 mt-auto relative">
      <div class="relative">
        <a
          class="flex items-center cursor-pointer gap-2 p-2 rounded-lg transition-colors hover:bg-white/5 dark:hover:bg-surface-800"
          (click)="userMenu.toggle($event)"
        >
          @if (user?.profilePicture) {
            <img
              [src]="user.profilePicture"
              class="w-8 h-8 rounded-full border-2 border-white/20 dark:border-white/10 object-cover"
            />
          } @else {
            <div
              class="w-8 h-8 rounded-full border-2 border-white/20 dark:border-white/10 bg-white/10 dark:bg-white/5 text-white/80 dark:text-white/70 flex items-center justify-center font-semibold text-sm uppercase"
            >
              {{ getInitials(user?.name) }}
            </div>
          }
          <div class="flex flex-col">
            <span class="font-medium text-base leading-tight text-white/90 dark:text-white/90">
              {{ user?.name || 'User' }}
            </span>
            <span class="text-xs text-white/60 dark:text-white/60">{{ user?.email }}</span>
          </div>
        </a>

        <p-popover
          [style]="{ '--p-popover-content-padding': 'none' }"
          #userMenu
          [dismissable]="true"
          class="w-48"
        >
          <div class="p-2 bg-surface-0 dark:bg-surface-900 rounded-lg shadow-lg">
            <!-- User Info -->
            <div class="px-3 py-2 border-b border-surface-100 dark:border-surface-700 mb-2">
              <div class="font-medium text-sm text-primary-900 dark:text-primary-100">
                {{ user?.name || 'User' }}
              </div>
              <div class="text-sm text-primary-600 dark:text-primary-400 truncate">
                {{ user?.email }}
              </div>
            </div>

            <!-- Change Password -->
            <button
              pRipple
              (click)="openChangePassword()"
              class="flex items-center w-full px-3 py-2 text-sm text-primary-900 dark:text-primary-100 hover:bg-surface-100 dark:hover:bg-surface-800 rounded-md transition-colors"
            >
              <i class="pi pi-lock mr-2"></i>
              <span>Change Password</span>
            </button>

            <!-- Logout Button -->
            <button
              pRipple
              (click)="logout()"
              class="flex items-center w-full px-3 py-2 text-sm text-primary dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-500/10 rounded-md transition-colors"
            >
              <i class="pi pi-sign-out mr-2"></i>
              <span>Logout</span>
            </button>
          </div>
        </p-popover>
      </div>
    </div>
  </div>
</div>

<app-change-password-dialog
  #changePasswordDialog
  mode="self"
></app-change-password-dialog>